import { graphql } from '../../gql';

export const FINAL_FORM = graphql(`
  query finalForm(
    $id: ID
    $internalName: String
    $token: String
    $isPolicystream: Boolean
  ) {
    finalForm(
      token: $token
      id: $id
      internalName: $internalName
      isPolicystream: $isPolicystream
    ) {
      ...FinalFormFields
    }
  }
`);
